import { PlainLink } from "core/components/link";
import {
  ICreateAccountFormFields,
  Register,
  createAccountFormFactory,
} from "core/components/register";
import { routeProps } from "core/utils/react-router-helpers";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { Redirect, RouteComponentProps, withRouter } from "react-router";
import Card from "study_reviewer/components/Card";
import * as routes from "study_reviewer/routes";
import {
  IState,
  createAccountRequest,
  getRegistrationCodeValidityRequest,
  resetIsRegistrationCodeValid,
  logoutRequest,
} from "study_reviewer/store";
import * as styles from "./LoginPage.css";

export interface IRouteParams {
  registrationCode: string;
}
interface IStateProps {
  isLoggedIn: boolean;
  registrationCode: string;
  isRegistrationCodeValid: boolean | null;
  hasCreatedAccount: boolean | null;
}
interface IDispatchProps {
  onMount: () => void;
  onLogout: () => void;
}
interface IOwnProps extends RouteComponentProps<IRouteParams> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

const CREATE_ACCOUNT_FORM_NAME = "create-account";
const onSubmit = (data: ICreateAccountFormFields, dispatch: Dispatch<void>) => {
  const { confirmPassword, ...rest } = data;
  dispatch(createAccountRequest(rest, CREATE_ACCOUNT_FORM_NAME));
};

class CreateAccountPageView extends React.Component<IProps, {}> {
  public render() {
    const { registrationCode, isRegistrationCodeValid, hasCreatedAccount } =
      this.props;
    if (isRegistrationCodeValid === null) return null;
    if (!isRegistrationCodeValid) return <Redirect to={routes.loginRoute()} />;
    const RegisterForm = createAccountFormFactory({
      formName: CREATE_ACCOUNT_FORM_NAME,
      onSubmit,
      registrationCode,
    });

    return (
      <div className={styles.page}>
        {hasCreatedAccount && (
          <Card>
            <Register
              {...routeProps<IProps, IRouteParams>(this.props)}
              theme={{ graphic: styles.graphic, lettering: styles.lettering }}
            />
            <h1 className={styles.title}>Your account has been created</h1>
            <p>
              Please{" "}
              <PlainLink to={routes.loginRoute()}>
                <u>login</u>
              </PlainLink>{" "}
              to access your account.
            </p>
          </Card>
        )}
        {!hasCreatedAccount && (
          <React.Fragment>
            <Card>
              <Register
                {...routeProps<IProps, IRouteParams>(this.props)}
                renderForm={() => (
                  <RegisterForm theme={{ error: styles.error }} />
                )}
                theme={{ graphic: styles.graphic, lettering: styles.lettering }}
              />
            </Card>
            <Card>
              <PlainLink className={styles.link} to={routes.loginRoute()}>
                Already have an account? <u>Login</u>
              </PlainLink>
            </Card>
          </React.Fragment>
        )}
      </div>
    );
  }

  componentWillReceiveProps(nextProps: IProps) {
    if (!nextProps.isLoggedIn && !nextProps.hasCreatedAccount) {
      this.props.onMount();
    }
  }

  public componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.onLogout();
    } else {
      this.props.onMount();
    }
  }
}

const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
  return {
    registrationCode: ownProps.match.params.registrationCode,
    isLoggedIn: !!state.login.token,
    isRegistrationCodeValid: state.technicians.isRegistrationCodeValid,
    hasCreatedAccount: state.register.hasCreatedAccount,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<void>, ownProps: IOwnProps) => ({
  onMount: () =>
    dispatch(
      getRegistrationCodeValidityRequest(ownProps.match.params.registrationCode)
    ),
  onLogout: () => dispatch(logoutRequest()),
});

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(
    mapStateToProps,
    mapDispatchToProps
  )(CreateAccountPageView)
);



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/CreateAccountPage.tsx